module.exports = __webpack_public_path__ + "assets/img/5b1de117bd5c85f7befb2282e9dbdcd8.png";